import { InjectionToken } from "@angular/core";
import { StaffVacationsPort } from "./staff-vacations.port";

export const STAFF_VACATIONS_PORT = new InjectionToken<StaffVacationsPort>(
  "STAFF_VACATIONS_PORT",
);
